import { render, staticRenderFns } from "./XYPlot.vue?vue&type=template&id=58497361&scoped=true&"
import script from "./XYPlot.vue?vue&type=script&lang=js&"
export * from "./XYPlot.vue?vue&type=script&lang=js&"
import style0 from "./XYPlot.vue?vue&type=style&index=0&id=58497361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58497361",
  null
  
)

export default component.exports